import React, { useState } from 'react';
import { Button, Modal, Form, Input, DatePicker } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"

const ComonFields = () => {
  
    return (
        <>
      
            <Form.Item name="amount" label="Số tiền"
                rules={[{
                    required: true,
                    message: "Bạn phải nhập số tiền"


                }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item name="description" label="Nội dung"
                rules={[{
                    required: true,
                    message: "Bạn phải nhập nội dung"
                }]}
            >
                <Input placeholder="Nội dung" />
            </Form.Item>
            <Form.Item name="date" label="Ngày"
                rules={[{
                    required: true,
                    message: "Bạn phải nhập nội dung"
                }]}
            >
                <DatePicker placeholder="input placeholder" />
            </Form.Item>


            <Form.Item name="images" label="Hình ảnh"

            >
                <ImagePicker></ImagePicker>
            </Form.Item>

        </>
    );
};
export default ComonFields;